<button
  (click)="onBackButtonClick($event)"
  class="btn btn_not-button select-form-header__button"
  type="button"
>
  <ui-icon class="ui-icon" name="angle-right" height="16" width="9"></ui-icon>
  {{ text }}
</button>
